import { Classes, Dialog } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import React, { useState } from "react";
import styles from "./ShiftFromDialog.module.scss";

/** Что сдвигаем «с даты»: проект целиком или раздел */
export interface ShiftFromTarget {
    kind: "project" | "section";
    orderId: string;
    /** Раздел; null — строка «Без раздела» */
    contentGuid?: string | null;
    /** Подпись в заголовке: «0500 Дом» или «КР3» */
    title: string;
    /** День под курсором, yyyy-MM-dd — дата по умолчанию */
    day: string;
}

interface ShiftFromDialogProps {
    target: ShiftFromTarget;
    onClose: () => void;
    /** fromDay — yyyy-MM-dd, shift — рабочих дней: плюс вправо, минус влево */
    onSubmit: (fromDay: string, shift: number) => void;
}

/**
 * «Сдвинуть с даты»: всё, что в проекте или разделе не раньше выбранного дня, уезжает на
 * N рабочих дней, а работы до этой даты остаются на месте — частый случай «с ноября всё
 * съезжает на две недели». Операция уходит в черновик, как перетаскивание.
 */
export const ShiftFromDialog: React.FC<ShiftFromDialogProps> = ({ target, onClose, onSubmit }) => {
    const [day, setDay] = useState(target.day);
    const [shift, setShift] = useState("5");

    const value = parseInt(shift, 10);
    const valid = !!day && Number.isFinite(value) && value !== 0;

    return (
        <Dialog isOpen={true} onClose={onClose} title={`Сдвинуть с даты · ${target.title}`} className="figma-dialog">
            <div className={`${Classes.DIALOG_BODY} ${styles.body}`}>
                <label className={styles.field}>
                    <span>С даты</span>
                    <input
                        type="date"
                        className={`${Classes.INPUT} planr-default-input`}
                        value={day}
                        onChange={(event) => setDay(event.target.value)}
                    />
                </label>

                <label className={styles.field}>
                    <span>На рабочих дней</span>
                    <input
                        type="number"
                        className={`${Classes.INPUT} planr-default-input`}
                        value={shift}
                        onChange={(event) => setShift(event.target.value)}
                    />
                </label>

                <div className={styles.hint}>
                    Плюс — вправо, минус — влево. Работы раньше этой даты, прошлое и работы других проектов
                    останутся на месте.
                </div>
            </div>

            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <PlanrButton type="secondary" size="small" onClick={onClose}>
                        Отмена
                    </PlanrButton>
                    <PlanrButton
                        type="greenish"
                        size="small"
                        disabled={!valid}
                        onClick={() => {
                            onSubmit(day, value);
                            onClose();
                        }}
                    >
                        Сдвинуть
                    </PlanrButton>
                </div>
            </div>
        </Dialog>
    );
};
